import {ReactElement} from 'react';

import {SVGIcon} from 'types';

export type BoxSection = {
  id: string;
  title: string;
  items: BoxItem[];
  maxItems?: number;
};

export enum BoxItemType {
  LINK = 'link',
  BUTTON = 'button',
}

export type BoxItem = DataTestId & (BoxLinkItem | BoxButtonItem);

type BaseItem = {
  id: string;
  title: string;
  Icon: SVGIcon;
  rightItem?: ReactElement;
};

export type BoxLinkItem = BaseItem & {
  type: BoxItemType.LINK;
  to: string;
};

export type BoxButtonItem = BaseItem & {
  type: BoxItemType.BUTTON;
  onClick: () => void;
};

export enum BoxListId {
  Opportunities = 'opportunities',
  MyLists = 'lists',
  Reminders = 'reminders',
}

export enum OpportunityBox {
  TargetIndustry = 'target-industry',
  NetNew = 'net-new',
  CrossSell = 'cross-sell',
  Monoline = 'monoline',
  Renewals = 'renewals',
  WinBack = 'win-back',
}

export enum OpportunitySearchType {
  Location = 'location',
  Company = 'company',
  People = 'people',
}
